import { Navigate } from 'react-router'

import { isSignedOut } from '@/api/client'
import { Splash } from '@/components/Splash'
import { ErrorState } from '@/components/StatusViews'
import { useMe } from '@/hooks/useMe'
import { readLastOrgSlug } from '@/lib/lastOrg'

/** "/": signed out → log in; no orgs yet → onboarding; otherwise the last org opened (or the first). */
export const HomeRedirect = () => {
  const me = useMe()
  if (me.isPending) return <Splash />
  if (me.isError) {
    if (isSignedOut(me.error)) return <Navigate to="/login" replace />
    return (
      <div className="p-6">
        <ErrorState error={me.error} onRetry={() => void me.refetch()} />
      </div>
    )
  }
  const { orgs } = me.data
  if (!orgs.length) return <Navigate to="/onboarding" replace />
  const lastSlug = readLastOrgSlug()
  const org = orgs.find((candidate) => candidate.slug === lastSlug) ?? orgs[0]
  return <Navigate to={`/o/${org?.slug}`} replace />
}
